import { Box } from "@material-ui/core";

export const BlockTitle = ({ children }: { children: string }) => {
  return <Box fontSize={19} fontWeight={700} component="h3">{children}</Box>;
};
